import { CommonModule } from '@angular/common';
import { Component, inject } from '@angular/core';
import { Router } from '@angular/router';
import { Store } from '@ngrx/store';
import { TranslatePipe } from '@ngx-translate/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { FilesControllerUploadDataImportFile200Response } from '../../../_generated';
import { getUploadReport } from '../../../store/selectors/file-import.selector';
import { FileReportComponent } from '../../components/file-report/file-report.component';

@Component({
  selector: 'app-report-page',
  standalone: true,
  imports: [CommonModule, FileReportComponent, TranslatePipe],
  template: `
    <div class="container mx-auto px-4 py-8">
      @if (report$ | async; as report) {
        <app-file-report [report]="report"></app-file-report>
      } @else {
        <div class="text-center py-12">
          <h2 class="text-xl font-semibold mb-4">{{ 'report.noReportAvailable' | translate }}</h2>
          <p class="text-gray-500 mb-6">{{ 'report.pleaseUploadFile' | translate }}</p>
          <button class="px-4 py-2 bg-primary-500 text-white rounded-lg hover:bg-primary-400" (click)="navigateToUpload()">
            {{ 'report.goToUpload' | translate }}
          </button>
        </div>
      }
    </div>
  `,
})
export class ReportPageComponent {
  private readonly store = inject<Store<any>>(Store);
  private readonly router = inject(Router);

  report$: Observable<FilesControllerUploadDataImportFile200Response | null> = this.store
    .select(getUploadReport)
    .pipe(map((uploadReport: any) => uploadReport ?? null));

  navigateToUpload(): void {
    this.router.navigate(['/']);
  }
}
